import React from "react";
import DesignYourFlyerIllustration from "components/icons/components/DesignYourFlyerIllustration";

interface FlyerBuilderEmptyStateProps {
  sidebarExpanded?: boolean;
}

const FlyerBuilderEmptyState: React.FC<FlyerBuilderEmptyStateProps> = ({ sidebarExpanded = false }) => {
  // Toolbar is always 48px; aside panel adds 216px when expanded
  const sidebarWidth = sidebarExpanded ? 264 : 48;

  return (
    <div
      onContextMenu={(e) => e.preventDefault()}
      style={{
        position: "absolute",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10,
        pointerEvents: "auto",
        background: "#F2F2F6",
        paddingLeft: sidebarWidth,
      }}
    >
      <DesignYourFlyerIllustration width={353} height={217} />
      <h1
        style={{
          fontFamily: "Inter",
          fontSize: 32,
          fontWeight: 700,
          lineHeight: "38px",
          color: "#011533",
          textAlign: "center",
          marginBottom: 8,
          marginTop: 24,
        }}
      >
        Start designing your flyer{" "}
      </h1>
      <p
        style={{
          fontFamily: "Inter",
          fontSize: 16,
          fontWeight: 400,
          color: "#011533",
          textAlign: "center",
          maxWidth: 465,
          fontFeatureSettings: "'liga' off, 'clig' off",
          lineHeight: "24px",
        }}
      >
        Choose an orientation and format to begin. You can upload your brand elements to make the process smoother and
        your design more personalized.{" "}
      </p>
    </div>
  );
};

export default FlyerBuilderEmptyState;
